
export default function ui(state = { message: null, loading: false, loadingMessage: null, messageType: false, showError: false, popup: null, popupInfo: null, popupFlag: true, progressBar: 0, randNumber: Math.floor(Math.random() * 4) }, action) {
    switch (action.type) {
        case 'SHOW_MESSAGE':
            return { ...state, message: action.payload, messageType: action.messageType }
        case 'SHOW_ERROR':
            return { ...state, showError: true }
        case 'CLEAR_MESSAGE':
            return { ...state, message: null, messageType: false }
        case 'LOADING_START':
            return { ...state, loading: true, loadingMessage: action.payload }
        case 'LOADING_END':
            return { ...state, loading: false, loadingMessage: null }
        case 'JUST_CHECKING':
            return { ...state }
        case 'SHOW_POPUP':
            return { ...state, popup: action.popup, popupInfo: action.popupInfo, popupFlag: action.popupFlag, progressBar: 0 }
        case 'CLOSE_POPUP':
            return { ...state, popup: null, popupInfo: null }
        case 'SHOW_PROGRESS':
            return { ...state, progressBar: action.payload }
        case 'RESET_PROGRESS':
            return { ...state, progressBar: 0 }
        case 'LOGOUT_USER':
            return { message: null, loading: false, loadingMessage: null, messageType: false, showError: false, popup: null, popupInfo: null, popupFlag: true, progressBar: 0, randNumber: Math.floor(Math.random() * 4) }
        default:
            return state
    }
}